import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Button } from '_zari/core'

import Yup from '_zari/validation/_yup'

import * as FormGroups from './formGroups'

import * as DocumentoRelacionadoService from 'services/documentoRelacionado.service'

const ValidationScheme = Yup.object().shape({
  tipoDetraccion: Yup.string().required(),
  importeDetraccion: Yup.number().required(),
  fechaDocumento: Yup.string().required(),
  numeroDocumento: Yup.string().required()
})

const EditarAsignarDetraccionModal = ({ handleClose, show, edicionData, reloadInfoDetraccion, idDocumentoPrincipal }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      _idDocumentoPrincipal: idDocumentoPrincipal,
      tipoDetraccion: edicionData.tipoDetraccion || '',
      importeDetraccion: edicionData.importeDetraccion || '',
      fechaDocumento: edicionData.fechaDocumento || '',
      numeroDocumento: edicionData.numeroDocumento || ''
    }
  }, [edicionData, idDocumentoPrincipal])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      const submitFunction = edicionData.fechaDocumento
        ? () => DocumentoRelacionadoService.actualizarDetraccionxId(edicionData._id, data)
        : () => DocumentoRelacionadoService.nuevaDetraccion(data)

      submitFunction()
        .then(() => {
          __zariContext.snack('success', 'Se han actualizado los datos de la detracción.')
          reloadInfoDetraccion()
          handleClose()
        })
        .catch(() => {
          __zariContext.snack('error', 'Se han actualizado los datos de la detracción.')
          setSubmitting(false)
        })
    },
    [__zariContext, edicionData, reloadInfoDetraccion, handleClose]
  )

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>INFO DETRACCION</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} validationSchema={ValidationScheme} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, handleSubmit }) => (
          <>
            <Modal.Body>
              <Form>
                <FormGroups.TipoDetraccionFormGroup iError={errors.tipoDetraccion} iTouched={touched.tipoDetraccion} fIsSubmitting={isSubmitting} />
                <FormGroups.ImporteDetraccionFormGroup
                  iError={errors.importeDetraccion}
                  iTouched={touched.importeDetraccion}
                  fIsSubmitting={isSubmitting}
                />
                <FormGroups.NumeroDocumentoFormGroup
                  iError={errors.numeroDocumento}
                  iTouched={touched.numeroDocumento}
                  fIsSubmitting={isSubmitting}
                />
                <FormGroups.FechaDocumentoFormGroup iError={errors.fechaDocumento} iTouched={touched.fechaDocumento} fIsSubmitting={isSubmitting} />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button id='button-formulariopagos-procesar' disabled={isSubmitting} onClick={handleSubmit}>
                Procesar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(EditarAsignarDetraccionModal)
